module.exports = __webpack_public_path__ + "static/img_mockup@2x-ca5dc5996386967e5faa8ea946d4f7fa.png";